import { CbSpacing400 } from '@coolblue-development/design-tokens';

export const pageTemplateColumns = `minmax(${CbSpacing400}, 1fr) minmax(0, 128rem) minmax(${CbSpacing400}, 1fr)`;
